import React from 'react'
import { ProductParameterExpansionProps } from './root-props'
import { productParameterExpansionStyles } from './styles'
import { ProductParameterExpansionImageBrowser } from './image-browser'
import { ProductParameterExpansionDesign } from './design'

export const ProductParameterExpansion = (props: ProductParameterExpansionProps<any>) => {
    const classes = productParameterExpansionStyles(props)
    switch (props.parameter.input) {
        case 'ImageBrowser': return <div className={classes.root}>
            <ProductParameterExpansionImageBrowser {...props} />
        </div>
        case 'ButtonBrowser': return <div className={classes.root}>
            <ProductParameterExpansionDesign {...props} />
        </div>
        default: return null
    }
}
